import { useEffect, useMemo } from 'react';
import { useIntl } from 'react-intl';

import AuthenticationStore from '~/auth/authenticationStore';
import { useAuthenticationStore } from '~/auth/useAuthenticationStore';
import { useTrackSegment } from '~/hooks/useTrackSegment ';
import { api } from '~/redux/api/createApi';
import { rolodex } from '~/redux/api/rolodex';

export const useGetWorkdayUpcApps = () => {
  const { deleteIsWorkdayUser, setIsWorkdayUser } = useMemo(
    () => AuthenticationStore(),
    [],
  );
  const intl = useIntl();
  const trackSegment = useTrackSegment();

  const { isWorkdayUser: persistedIsWorkdayUser } = useAuthenticationStore();

  const { data: isWorkdayUser = persistedIsWorkdayUser ?? false } =
    rolodex.useGetIsWorkdayUserQuery();

  const { data: apps, isError } = api.endpoints.getWorkdayUpcApps.useQuery(
    {},
    { skip: !isWorkdayUser },
  );

  const appsError = useMemo(() => {
    if (isError) {
      return [
        {
          href: '',
          id: 'workday-upc-apps-error',
          isCurrentApplication: true, // sets disabled state
          label: intl.formatMessage({
            id: 'WorkdayUpcApps.error',
            defaultMessage:
              'Failed to retrieve applications. Refresh the page to try again.',
            description:
              'Error message displayed when fetching Workday UPC apps fails',
          }),
        },
      ];
    }
  }, [isError, intl]);

  useEffect(() => {
    if (isWorkdayUser) {
      setIsWorkdayUser(true);
    } else {
      deleteIsWorkdayUser();
    }
    if (isWorkdayUser && (apps || isError)) {
      // Track requests to Calypso from Pilot
      trackSegment('Fetch Workday UPC apps from Calypso', {});
    }
  }, [
    apps,
    deleteIsWorkdayUser,
    isError,
    isWorkdayUser,
    setIsWorkdayUser,
    trackSegment,
  ]);

  return { apps: isError ? appsError : apps, isWorkdayUser };
};
